/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Help interface.
 */
export function instanceOfHelp(value) {
    if (!("progress" in value) || value.progress === undefined)
        return false;
    return true;
}
export function HelpFromJSON(json) {
    return HelpFromJSONTyped(json, false);
}
export function HelpFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        progress: json.progress,
    };
}
export function HelpToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        progress: value.progress,
    };
}
